export const itemReferenceName = (_state, getters) => (item, relation = 'reference') => {
    let reference_type = item[`${relation}_type`]
    let reference_id = item[`${relation}_id`]

    switch (reference_type) {
        case 'user':
            return getters.userNameById(reference_id)
        case 'contact':
            return getters.contactNameById(reference_id)
        case 'task':
            return getters.taskNameById(reference_id)
        case 'service':
            return getters.serviceNameById(reference_id)
        case 'project-service':
            let item = getters.projectServiceById(reference_id)
            return item ? item.title : ''
        case 'company':
            return getters.companyNameById(reference_id)
        case 'work-type':
            return getters.workTypeNameById(reference_id)
        case 'project':
            return getters.projectNameById(reference_id)
        case 'proposal':
            return getters.proposalNameById(reference_id)
        case 'change-order':
            let co = getters.changeOrderById(reference_id)
            return co ? co.number : ''
        default:
            return '';
    }
}

export const itemReference = (_state, getters) => (item, relation = 'reference') => {
    let reference_type = item[`${relation}_type`]
    let reference_id = item[`${relation}_id`]

    switch (reference_type) {
        case 'task':
            return getters.taskById(reference_id)
        case 'service':
            return getters.serviceById(reference_id)
        case 'company':
            return getters.companyById(reference_id)
        case 'project':
            return getters.projectById(reference_id)
        case 'work-type':
            return getters.workTypeById(reference_id)
        default:
            return null;
    }
}

export const itemReferenceLink = (_state, getters) => (item, relation = 'reference') => {
    let reference_type = item[`${relation}_type`]
    let reference_id = item[`${relation}_id`]

    switch (reference_type) {
        case 'service':
            return `/services/${reference_id}`
        //case 'work-type':
        //    return getters.workTypeById(reference_id)
        case 'company':
            return `/companies/${reference_id}`
        case 'project-service':
            let ps = getters.projectServiceById(reference_id)

            return ps ? `/projects/${ps.project_id}/services` : '/'
        case 'task':
            return `/tasks/${reference_id}`
        case 'project':
            return `/projects/${reference_id}`
        case 'proposal':
            return `/proposals/${reference_id}`
        case 'change-order':
            let co = getters.changeOrderById(reference_id)
            return co ? `/projects/${co.project_id}/change-orders` : '/'
        default:
            return ''
    }
}

export const itemReferenceProjectName = (_state, getters) => (item, relation = 'reference') => {
    let reference_type = item[`${relation}_type`]
    let reference_id = item[`${relation}_id`]

    switch (reference_type) {
        case 'project':
            return getters.projectNameById(reference_id)
        case 'proposal':
            let proposal = getters.proposalById(reference_id)
            return proposal ? getters.projectNameById(proposal.project_id) : ''
        case 'project-service':
            let ps = getters.projectServiceById(reference_id)
            return ps ? getters.projectNameById(ps.project_id) : ''
        case 'task':
            let task = getters.taskById(reference_id)
            return task ? getters.projectNameById(task.project_id) : ''
        default:
            return ''
    }
}

export const itemReferenceProject = (_state, getters) => (item, relation = 'reference') => {
    let reference_type = item[`${relation}_type`]
    let reference_id = item[`${relation}_id`]

    switch (reference_type) {
        case 'project':
            return reference_id
        case 'proposal':
            let proposal = getters.proposalById(reference_id)
            return proposal ? proposal.project_id : ''
        case 'project-service':
            let ps = getters.projectServiceById(reference_id)
            return ps ? ps.project_id : ''
        case 'task':
            let task = getters.taskById(reference_id)
            return task ? task.project_id : ''
        default:
            return ''
    }
}

export const checkIfprojectIdExists = (_state, getters) => (item, relation = 'reference') => {
    let reference_type = item[`${relation}_type`]
    let reference_id = item[`${relation}_id`]

    switch (reference_type) {
        case 'project':
            return true
        case 'proposal':
            let proposal = getters.proposalById(reference_id)?.project_id
            return !!proposal
        case 'project-service':
            let ps = getters.projectServiceById(reference_id)?.project_id
            return !!ps
        case 'task':
            let task = getters.taskById(reference_id)?.project_id
            return !!task
        default:
            return false
    }
}